import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  quote: "Chipper Mulching transformed our overgrown lot into a beautiful, usable space in just one day. Their forestry mulching technique is incredibly efficient and clean.",
  name: "James Henderson",
  role: "Property Owner",
  location: "Asheville, NC",
  badgeText: "Lot Preparation"
}, {
  quote: "The team cleared a perfect trail system through our wooded acreage. They were professional, on time, and the results exceeded our expectations for the price.",
  name: "Elena Rodriguez",
  role: "Estate Manager",
  location: "Greenville, SC",
  badgeText: "Path & Trail Clearing"
}, {
  quote: "I needed brush removal for fire safety. Chipper Mulching handled the overgrowth quickly and left the soil enriched. Highly recommend their clearing services.",
  name: "Marcus Thorne",
  role: "Homeowner",
  location: "Knoxville, TN",
  badgeText: "Brush Removal"
}];
export default function SuccessStories() {
  return <section data-section-id="258386" id="contact-form-section" className="bg-background py-24">
      <div className="page-container">
        {}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-primary font-default font-bold tracking-wider text-sm uppercase mb-4 block">
            Client Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-6">
            What Our Clients Are Saying
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Discover why property owners trust Chipper Mulching Co. for professional land clearing and forestry services.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, i) => <Card key={i} data-index={i} className="relative overflow-hidden border-none shadow-lg bg-secondary">
              {}
              <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-primary/10 rounded-lg blur-3xl pointer-events-none" />
              
              <CardContent className="p-8 flex flex-col h-full relative z-10">
                {}
                <div className="flex justify-between items-start mb-6">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-5 fill-primary text-primary" />)}
                  </div>
                  <Quote className="size-12 text-primary/20 rotate-180" strokeWidth={1} fill="currentColor" />
                </div>

                {}
                <p className="text-secondary-foreground text-lg leading-relaxed flex-grow mb-8 font-sans">
                  "{testimonial.quote}"
                </p>

                {}
                <div className="flex items-end justify-between border-t border-white/10 pt-6 mt-auto">
                  <div>
                    <h4 className="font-default font-bold text-secondary-foreground text-lg">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-secondary-foreground/70 mt-1 font-sans">
                      {testimonial.role}
                      <br />
                      {testimonial.location}
                    </p>
                  </div>
                  <div className="bg-primary text-primary-foreground px-3 py-1.5 rounded-md text-xs font-bold text-right max-w-[130px] leading-tight shadow-sm">
                    {testimonial.badgeText}
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}